import { useTranslation } from "react-i18next";

import { BackLink } from "@/components/BackLink";
import { FinalCtaSection, IMAGES, H_SECTION, SUBLINE } from "@/components/marketing/Sections";
import { useJsonLd, usePageMeta } from "@/lib/seo";
import { BRAND } from "@/config/brand";

/* Editorial about page — enormous type, photography, plain text columns. No cards, no icons. */
export default function About() {
  const { t } = useTranslation();
  usePageMeta({ title: `${t("about.eyebrow")} — ${BRAND.name}`, description: t("about.p1"), localized: true });
  useJsonLd({
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: t("about.title"),
    description: t("about.p1"),
    about: { "@type": "Organization", name: BRAND.name },
  });
  return (
    <div data-testid="about-page">
      <section className="bg-white pt-10">
        <div className="max-w-[980px] mx-auto px-6">
          <BackLink fallback="/" testid="about-back-link" />
        </div>
        <div className="max-w-[980px] mx-auto px-6 pt-10 lg:pt-14 text-center flex flex-col items-center gap-6">
          <h1 className={`${H_SECTION} text-[#1d1d1f] max-w-3xl`}>{t("about.title")}</h1>
          <p className={`${SUBLINE} text-[#6e6e73] max-w-2xl`}>{t("about.p1")}</p>
        </div>
        <div className="mt-14 lg:mt-20">
          <img src={IMAGES.about} alt="" className="w-full h-[400px] lg:h-[600px] object-cover" loading="lazy" />
        </div>
      </section>

      <section className="bg-[#f5f5f7]">
        <div className="max-w-[980px] mx-auto px-6 py-20 lg:py-28 flex flex-col gap-16">
          <p className="text-xl lg:text-[28px] font-normal text-[#1d1d1f] leading-snug max-w-3xl">{t("about.p2")}</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {["value1", "value2", "value3"].map((key) => (
              <div key={key} className="flex flex-col gap-2">
                <h2 className="text-[17px] font-semibold text-[#1d1d1f]">{t(`about.${key}Title`)}</h2>
                <p className="text-sm text-[#6e6e73] leading-relaxed">{t(`about.${key}Desc`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FinalCtaSection />
    </div>
  );
}
